<template>
  <Card class="job-detail">
    <div class="content">
      <div class="main" id="job-detail-main">
        <ScriptShow ref="ScriptShow"></ScriptShow>
        <JobExecModal ref="JobExecModal" v-on:getExecLogsList="getExecLogs()"></JobExecModal>
        <JobExecConfirm ref="JobExecConfirm" v-on:execComplete="getExecLogs()"></JobExecConfirm>
        <div>
          <Row>
            <Col :xs="24" :sm="24" :md="24" :lg="12" :style="{padding: '0 5px 10px 5px'}">
              <div style="margin-bottom: 15px">
                <Row class="title">
                  <h4 :style="{float: 'left'}">作业详情</h4>
                  <div :style="{float: 'right'}">
                    <Button type="success" @click="exec" style="margin-right: 10px">执行</Button>
                    <Button type="primary" @click="edit" style="margin-right: 10px">编辑</Button>
                    <Button @click="$router.push({ name: 'job_center' })">返回</Button>
                  </div>
                </Row>
                <Alert v-if="infoError" type="warning" show-icon>获取作业数据失败</Alert>
                <div class="info-property" v-else>
                  <dl>
                    <dt>ID</dt><dd>{{ info.id }}</dd>
                  </dl>
                  <dl>
                    <dt>作业名称</dt><dd>{{ info.name }}</dd>
                  </dl>
                  <dl>
                    <dt>作业描述</dt><dd>{{ info.desc }}</dd>
                  </dl>
                  <dl>
                    <dt>创建用户</dt><dd>{{ info.create_user_full_name }}</dd>
                  </dl>
                  <dl>
                    <dt>创建时间</dt><dd>{{ info.created_format }}</dd>
                  </dl>
                  <dl>
                    <dt>最后修改用户</dt><dd>{{ info.change_user_full_name }}</dd>
                  </dl>
                  <dl>
                    <dt>修改时间</dt><dd>{{ info.changed_format }}</dd>
                  </dl>
                </div>
              </div>
              <div style="margin-bottom: 15px">
                <Row class="title">
                  <h4 :style="{float: 'left'}">执行记录</h4>
                  <a v-on:click="getExecLogs()" style="line-height: 32px; padding-left: 10px"><Icon type="md-refresh" size="18"/></a>
                </Row>
                <Row>
                  <Alert v-if="execHistory.error" type="warning" show-icon>获取执行记录数据失败</Alert>
                  <Table
                    v-else
                    border
                    size="small"
                    :height="0"
                    :loading="execHistory.loading"
                    ref="table"
                    :data="execHistory.data"
                    :columns="execHistory.columns">
                  </Table>
                  <div style="margin: 10px 0; overflow: hidden;">
                    <div style="float: right;">
                      <page
                        :total="execHistory.count"
                        :current="execHistory.page"
                        :page-size="execHistory.size"
                        @on-change="getExecLogs"></page>
                    </div>
                  </div>
                </Row>
              </div>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="12" :style="{padding: '0 5px 10px 5px'}">
              <Row class="title">
                <h4 :style="{float: 'left'}">作业步骤</h4>
                <div style="float: right;">
                  <i-switch v-model="stepsDetailShow" size="large" @on-change="stepsDetailShowChange">
                    <span slot="open">详细</span>
                    <span slot="close">折叠</span>
                  </i-switch>
                </div>
              </Row>
              <Row>
                <Alert v-if="stepsError" type="warning" show-icon>获取作业步骤数据失败</Alert>
                <Card style="margin-bottom: 10px" v-for="(step, index) in steps" :key="index">
                  <div slot="title" style="height: 14px">
                    <div style="float: left; height: 14px">
                      <Icon type="md-list-box" />
                      <b>步骤 {{ index + 1 }}</b>
                    </div>
                  </div>
                  <div :class="{'circle-step-type': true, 'circle-step-type-script': step.type === 'script',
                  'circle-step-type-message': step.type === 'message' }" style="float: right">
                    <span class="step-type-span" v-if="step.type === 'script'">脚本</span>
                    <span class="step-type-span" v-else-if="step.type === 'message'">消息</span>
                  </div>
                  <div>
                    <div class="info-property" style="padding: 0; border: none; box-shadow: none">
                      <dl>
                        <dt>步骤名称</dt><dd>{{ step.name }}</dd>
                      </dl>
                      <dl>
                        <dt>完成后是否暂停</dt>
                        <dd>
                          <span v-if="step.is_suspend === true">是</span>
                          <span v-else-if="step.is_suspend === false">否</span>
                        </dd>
                      </dl>
                      <dl>
                        <dt>是否跳过错误</dt>
                        <dd>
                          <span v-if="step.is_jump_error === true">是</span>
                          <span v-else-if="step.is_jump_error === false">否</span>
                        </dd>
                      </dl>
                      <dl>
                        <dt>完成后延迟时间</dt><dd>{{ step.delay }} (秒)</dd>
                      </dl>
                      <div v-if="stepsDetailShow || step.show_all">
                        <div v-if="step.type === 'script'" v-for="script in step.job_script_step" :key="index + 'script_' + script.id">
                          <dl>
                            <dt>脚本名称</dt>
                            <dd>{{ script.name }}</dd>
                          </dl>
                          <dl>
                            <dt>脚本类型</dt>
                            <dd>{{ script.type }}</dd>
                          </dl>
                          <dl>
                            <dt>脚本内容</dt>
                            <dd><a v-on:click="viewScript(script.content, script.type)">查看</a></dd>
                          </dl>
                          <dl>
                            <dt>脚本参数</dt>
                            <dd>{{ script.params }}</dd>
                          </dl>
                          <dl>
                            <dt>用户凭证</dt>
                            <dd>{{ script.certificate_name }}</dd>
                          </dl>
                          <dl>
                            <dt>目标服务器</dt>
                            <dd>
                              <Tag color="primary" v-for="(sValue, sIndex) in script.servers" :key="'targets_' + index + '_' + sIndex">{{ sValue }}</Tag>
                            </dd>
                          </dl>
                        </div>
                        <div v-if="step.type === 'message'" v-for="message in step.job_message_step" :key="index + 'message_' + message.id">
                          <dl>
                            <dt>消息标题</dt>
                            <dd>{{ message.title }}</dd>
                          </dl>
                          <dl>
                            <dt>消息类型</dt>
                            <dd>{{ message.type }}</dd>
                          </dl>
                          <dl>
                            <dt>消息内容</dt>
                            <dd><pre>{{ message.content }}</pre></dd>
                          </dl>
                          <dl>
                            <dt>收件人</dt>
                            <dd>
                              <Tag color="success" v-for="(sValue, sIndex) in message.users" :key="'targets_' + index + '_' + sIndex">{{ sValue }}</Tag>
                            </dd>
                          </dl>
                        </div>
                      </div>
                      <div v-else>
                        <dl>
                          <dt><Tooltip content="点击展开"><a v-on:click="stepShowAll(index)"><b>......</b></a></Tooltip></dt>
                          <dd></dd>
                        </dl>
                      </div>
                    </div>
                  </div>
                </Card>
              </Row>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  </Card>
</template>

<script>
import { detailOpsCenterJob, getOpsCenterJobExecLog, getOpsCenterJobSteps,
  getOpsCenterJobUnfinishedExecLog } from '@/api/opscenter'
import ScriptShow from '../script-show'
import JobExecModal from './job-exec-modal'
import JobExecConfirm from './job-exec-confirm'

export default {
  name: 'job-detail',
  components: {
    ScriptShow,
    JobExecModal,
    JobExecConfirm
  },
  data () {
    return {
      info: {},
      infoError: false,
      execHistory: {
        data: [],
        columns: [
          {
            title: '开始时间',
            key: 'started_format',
            align: 'center',
            minWidth: 150
          },
          {
            title: '结束时间',
            key: 'ended_format',
            align: 'center',
            minWidth: 150
          },
          {
            title: '耗时(秒)',
            key: 'use_time',
            align: 'center',
            minWidth: 100
          },
          {
            title: '执行用户',
            key: 'execute_user_full_name',
            align: 'center',
            minWidth: 120
          },
          {
            title: '执行状态',
            key: 'status',
            minWidth: 90,
            fixed: 'right',
            align: 'center',
            render: (h, params) => {
              let iconType = 'md-clock'
              let style = {
                color: '#2d8cf0'
              }
              if (params.row.status === '完成') {
                iconType = 'md-checkmark'
                style.color = '#19be6b'
              } else if (params.row.status === '暂停') {
                iconType = 'ios-pause'
                style.color = '#ff9900'
              } else if (params.row.status === '执行中') {
                iconType = 'ios-loading'
                style.color = '#ff9900'
                style.animation = 'ani-demo-spin 1s linear infinite'
              }
              return h('div', [
                h('Icon', {
                  props: {
                    type: iconType,
                    size: 16
                  },
                  style: style
                }),
                h('span', {
                  style: {
                    color: style.color
                  }
                }, ' ' + params.row.status)
              ])
            }
          },
          {
            title: '操作',
            width: 70,
            fixed: 'right',
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.getExecLogDetail(params.row.id)
                    }
                  }
                }, '详情')
              ])
            }
          }
        ],
        error: false,
        count: 0,
        page: 1,
        size: 5,
        loading: false
      },
      stepsError: false,
      stepsDetailShow: false,
      steps: []
    }
  },
  watch: {
    '$route' () {
      if (this.$route.params.id) {
        this.init()
      }
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    // 初始化
    init () {
      this.getData()
      this.getJobStepsData()
      this.getExecLogs()
      this.listener()
    },
    // 获取作业数据
    getData () {
      this.infoError = false
      detailOpsCenterJob(this.$route.params.id).then(res => {
        this.info = res.data
      }).catch(res => {
        this.infoError = true
        this.$Notice.error({ title: '获取作业数据失败' })
      })
    },
    // 获取作业步骤
    getJobStepsData () {
      this.stepsError = false
      getOpsCenterJobSteps({ job: this.$route.params.id }).then(res => {
        this.steps = res.data
      }).catch(res => {
        this.stepsError = true
        this.$Notice.error({ title: '获取作业步骤数据失败' })
      })
    },
    // 执行
    exec () {
      this.$refs.JobExecConfirm.exec(this.$route.params.id)
    },
    // 编辑
    edit () {
      getOpsCenterJobUnfinishedExecLog({ job: this.$route.params.id }).then(res => {
        if (res.data) {
          this.$Notice.warning({
            title: '操作失败！',
            desc: '当前作业正在执行，不允许编辑'
          })
        } else {
          this.$router.push({
            name: 'job_edit',
            params: { id: this.$route.params.id }
          })
        }
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败，获取执行数据失败!',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },
    // 获取执行记录
    getExecLogs (value = 1) {
      this.execHistory.page = value
      let params = {
        size: this.execHistory.size,
        page: this.execHistory.page,
        job: this.$route.params.id
      }
      this.execHistory.error = false
      this.execHistory.loading = true
      getOpsCenterJobExecLog(params).then(res => {
        this.execHistory.loading = false
        this.execHistory.data = res.data.results
        this.execHistory.count = res.data.count
      }).catch(res => {
        this.execHistory.loading = false
        this.execHistory.data = []
        this.execHistory.count = 0
        this.execHistory.error = true
        this.$Notice.error({ title: '获取执行记录数据失败' })
      })
    },
    // 获取执行记录详情
    getExecLogDetail (id) {
      this.$refs.JobExecModal.openExecModal(id, this.$route.params.id)
    },
    // 查看脚本
    viewScript (content, type) {
      let data = {
        content: content,
        type: type
      }
      this.$refs.ScriptShow.openModal(data, true, true)
    },
    stepShowAll (index) {
      this.steps[index].show_all = true
    },
    stepsDetailShowChange (ss) {
      if (!ss) {
        for (let i in this.steps) {
          this.steps[i].show_all = false
        }
      }
    },
    // 监听WS消息
    listener () {
      this.$options.sockets.onmessage = (data) => {
        const fData = JSON.parse(data.data)
        if (fData.group === 'message' && fData.service === 'opscenter' && fData.module === 'job') {
          if (fData.data) {
            if (fData.data.job_id + '' === this.$route.params.id + '') {
              this.getExecLogs(this.execHistory.page)
            }
          }
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../base.less';
  #job-detail-main .circle-step-type {
    line-height: 50px;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    -moz-border-radius: 50%;
    -webkit-border-radius: 50%;
    margin: 4px;
    text-align: center;
  }
  #job-detail-main .circle-step-type-script {
    background-color: #2d8cf0;
  }
  #job-detail-main .circle-step-type-message {
    background-color: #19be6b;
  }
  #job-detail-main .step-type-span{
    color: #ffffff;
    font-size: 17px;
    line-height: 50px;
  }
</style>
